import ShopNameItemView from '@/src/pages/channel_list/components/ShopCard/items/shop_name/view';
import ShopNameItemModel from '@/src/pages/channel_list/components/ShopCard/items/shop_name/model/ShopNameItemModel';
import DynamicTagGroupItemView from '@/src/pages/channel_list/components/ShopCard/items/dynamic_tags/view';
import DymaticTagGroupItemModel from '@/src/pages/channel_list/components/ShopCard/items/dynamic_tags/model/DynamicTagGroupItemModel';
import ShopScoreItemModel
  from '@/src/pages/channel_list/components/ShopCard/items/shop_score/model/ShopScoreItemModel';
import ShopAvgSpendRichTextItemModel
  from '@/src/pages/channel_list/components/ShopCard/items/rich_text_items/ShopAvgSpendRichTextItemModel';
import DeliveryTimeModel
  from '@/src/pages/channel_list/components/ShopCard/items/delivery_time/model/DeliveryTimeModel';
import DistanceRichTextItemModel
  from '@/src/pages/channel_list/components/ShopCard/items/rich_text_items/DistanceRichTextItemModel';
import DiscountBarItemView from '@/src/pages/channel_list/components/ShopCard/items/discount_Bar/view';
import DiscountBarItemModel
  from '@/src/pages/channel_list/components/ShopCard/items/discount_Bar/model/DiscountBarItemModel';
import ShopSaleInfoRichTextItemModel
  from '@/src/pages/channel_list/components/ShopCard/items/rich_text_items/ShopSaleInfoRichTextItemModel';
import ShopCategoryRichTextItemModel
  from '@/src/pages/channel_list/components/ShopCard/items/rich_text_items/ShopCategoryRichTextItemModel';
import MinCostPriceRichTextItemModel
  from '@/src/pages/channel_list/components/ShopCard/items/rich_text_items/MinCostPriceRichTextItemModel';
import ShopScoreItemView from '@/src/pages/channel_list/components/ShopCard/items/shop_score/view';
import DeliveryTimeItemView from '@/src/pages/channel_list/components/ShopCard/items/delivery_time/view';
import DeliveryFeeItemModel
  from '@/src/pages/channel_list/components/ShopCard/items/delivery_fee/model/DeliveryFeeItemModel';
import DeliveryFeeItemView from '@/src/pages/channel_list/components/ShopCard/items/delivery_fee/view';

export const ItemConfigs = {
  shopName: {
    view: ShopNameItemView,
    model: ShopNameItemModel
  },
  dynamicTags: {
    view: DynamicTagGroupItemView,
    model: DymaticTagGroupItemModel
  },
  shopScore: {
    view: ShopScoreItemView,
    model: ShopScoreItemModel
  },
  shopAvgSpend: {
    model: ShopAvgSpendRichTextItemModel
  },
  deliveryTime: {
    model: DeliveryTimeModel,
    view: DeliveryTimeItemView
  },
  distance: {
    model: DistanceRichTextItemModel
  },
  deliveryFee: {
    model: DeliveryFeeItemModel,
    view: DeliveryFeeItemView
  },
  discountBar: {
    view: DiscountBarItemView,
    model: DiscountBarItemModel
  },
  shopSaleInfo: {
    model: ShopSaleInfoRichTextItemModel
  },
  shopCategory: {
    model: ShopCategoryRichTextItemModel
  },
  minCostPrice: {
    model: MinCostPriceRichTextItemModel
  }
};
